var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        ((_vm.isInfoEvent || _vm.isFutureEvent) && !_vm.isListCard
          ? "info-card"
          : "") + (_vm.$q.platform.is.mobile ? " mobile" : ""),
      style: _vm.cssVars
    },
    [
      (_vm.isInfoEvent || _vm.isFutureEvent) && !_vm.isListCard
        ? _c("div", { staticClass: "image-overlay" }, [
            _c("div", {
              staticClass: "overlay-bkg",
              style: {
                "background-image":
                  "url(" +
                  (_vm.eventImage ? _vm.eventImage : _vm.defaultImage) +
                  ")"
              }
            })
          ])
        : _vm._e(),
      _c(
        "q-card",
        {
          ref: _vm.eventCode,
          class: {
            "text-black": _vm.featured,
            mini: !_vm.visible.description && !_vm.isInfoEventPage
          },
          attrs: {
            slug: _vm.eventSlug,
            square: _vm.square && !(_vm.isInfoEvent || _vm.isFutureEvent),
            flat: _vm.flat && !(_vm.isInfoEvent || _vm.isFutureEvent),
            inline: _vm.isInfoEvent || _vm.isFutureEvent ? false : _vm.inline,
            "data-test": _vm.CypressTarget("EventCard"),
            "aria-label": _vm.ariaEventShortDescription,
            tabindex: "0"
          },
          nativeOn: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "space", 32, $event.key, " ")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.goToEventSpaceBar($event)
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "q-card-media",
                [
                  (_vm.visible.name ||
                    _vm.visible.serie ||
                    _vm.visible.dateTime) &&
                  _vm.visible.informationOnPoster
                    ? _c(
                        "div",
                        {
                          staticClass: "eventData row",
                          class: [
                            _vm.visible.centerTitle || _vm.centerTitle
                              ? "content-center items-center"
                              : "content-end items-end"
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-xs-12",
                              class: {
                                "content-center items-center fit":
                                  _vm.visible.centerTitle || _vm.centerTitle
                              }
                            },
                            [
                              _c(
                                "q-list",
                                {
                                  class: {
                                    "content-center items-center fit":
                                      _vm.visible.centerTitle || _vm.centerTitle
                                  },
                                  attrs: { "no-border": "" }
                                },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      class: {
                                        fit:
                                          _vm.visible.centerTitle ||
                                          _vm.centerTitle
                                      }
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _vm.visible.name && _vm.eventName
                                            ? _c(
                                                "q-item-tile",
                                                {
                                                  staticClass: "title",
                                                  class: {
                                                    "title-card": !(
                                                      _vm.square && _vm.flat
                                                    ),
                                                    "text-center":
                                                      _vm.visible.centerTitle ||
                                                      _vm.centerTitle
                                                  },
                                                  attrs: {
                                                    "data-test": _vm.CypressTarget(
                                                      "Name"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.isOnPreSale
                                                          ? "[" +
                                                              _vm.$t(
                                                                "text.preSales.eventTitleLabel"
                                                              ) +
                                                              "]"
                                                          : ""
                                                      ) +
                                                      "\n                    " +
                                                      _vm._s(_vm.eventName) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.visible.serie && _vm.eventSubtitle
                                            ? _c(
                                                "q-item-tile",
                                                {
                                                  staticClass: "eventSubtitle",
                                                  class: {
                                                    "text-center":
                                                      _vm.visible.centerTitle ||
                                                      _vm.centerTitle
                                                  },
                                                  attrs: {
                                                    "data-test": _vm.CypressTarget(
                                                      "Serie"
                                                    ),
                                                    sublabel: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.eventSubtitle
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.visible.dateTime && _vm.dateTime
                                            ? _c(
                                                "q-item-tile",
                                                {
                                                  staticClass: "date",
                                                  class: {
                                                    "text-center":
                                                      _vm.visible.centerTitle ||
                                                      _vm.centerTitle
                                                  },
                                                  attrs: {
                                                    "data-test": _vm.CypressTarget(
                                                      "DateTime"
                                                    ),
                                                    sublabel: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(_vm.dateTime) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    staticClass: "image-media",
                    attrs: {
                      src: _vm.eventImage ? _vm.eventImage : _vm.defaultImage
                    },
                    on: { error: _vm.imgErrorManipulator }
                  }),
                  _vm.display.soldOutCorner && _vm.soldOut && !_vm.ticketsInCart
                    ? _c("corner-tab", {
                        attrs: {
                          label: _vm.$t("label.soldOut"),
                          color: _vm.SET_COLOR.primary,
                          "text-color": _vm.SET_TEXT_COLOR.primary
                        }
                      })
                    : _vm._e(),
                  !_vm.isInfoEvent && _vm.isFutureEvent && _vm.isListCard
                    ? _c("corner-tab", {
                        attrs: {
                          label: _vm.$t("label.soon"),
                          color: _vm.SET_COLOR.primary,
                          "text-color": _vm.SET_TEXT_COLOR.primary
                        }
                      })
                    : _vm._e(),
                  _vm.isInfoEvent && _vm.isListCard
                    ? _c("corner-tab", {
                        attrs: {
                          label: _vm.$t("label.info"),
                          color: _vm.SET_COLOR.primary,
                          "text-color": _vm.SET_TEXT_COLOR.primary
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              !_vm.flat
                ? _c("DataShare", {
                    attrs: {
                      shared: _vm.getSharedData,
                      color: _vm.SET_COLOR.primary
                    }
                  })
                : _vm._e(),
              !_vm.visible.informationOnPoster || _vm.isInfoEventPage
                ? _c("q-card-title", [
                    (_vm.visible.name || _vm.isInfoEventPage) && _vm.eventName
                      ? _c("span", { staticClass: "card-title" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isOnPreSale
                                  ? "[" +
                                      _vm.$t("text.preSales.eventTitleLabel") +
                                      "]"
                                  : ""
                              ) +
                              "\n          " +
                              _vm._s(_vm.eventName) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.visible.serie && _vm.eventSubtitle
                      ? _c(
                          "span",
                          { attrs: { slot: "subtitle" }, slot: "subtitle" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.eventSubtitle) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.visible.dateTime && _vm.dateTime
                      ? _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            attrs: { slot: "subtitle" },
                            slot: "subtitle"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.dateTime) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              (_vm.$q.platform.is.mobile || _vm.isFutureEvent) &&
              (_vm.visible.description || _vm.isInfoEventPage)
                ? _c(
                    "div",
                    { staticClass: "menu" },
                    _vm._l(_vm.getMenus, function(menu) {
                      return _c("menu-button", {
                        key: menu.id,
                        staticClass: "menu-item",
                        attrs: {
                          label: menu.label,
                          color: _vm.isMenuActive(menu.id)
                            ? _vm.SET_COLOR.primary
                            : "white",
                          "text-color": _vm.isMenuActive(menu.id)
                            ? "white"
                            : "black",
                          flat: !_vm.isMenuActive(menu.id)
                        },
                        on: {
                          click: function($event) {
                            _vm.clickToMenu(menu.id)
                          }
                        }
                      })
                    })
                  )
                : _vm._e(),
              (_vm.visible.main && _vm.anyDataInformation) ||
              _vm.isInfoEventPage
                ? _c(
                    "q-card-main",
                    { staticClass: "no-padding-sides" },
                    [
                      _vm.showShortDescription
                        ? _c("h1", {
                            directives: [
                              {
                                name: "dompurify-html",
                                rawName: "v-dompurify-html",
                                value: _vm.eventShortDescription,
                                expression: "eventShortDescription"
                              }
                            ],
                            staticClass: "padding-sides fix-images",
                            attrs: {
                              "data-test": _vm.CypressTarget("ShortDescription")
                            }
                          })
                        : _vm._e(),
                      _vm.visible.place &&
                      _vm.eventAddress &&
                      (_vm.menuActive === _vm.getMenuTickets ||
                        !(_vm.$q.platform.is.mobile || _vm.isFutureEvent))
                        ? _c(
                            "div",
                            { staticClass: "q-mb-sm" },
                            [
                              _c("q-card-separator"),
                              _c(
                                "q-list",
                                { attrs: { "no-border": "" } },
                                [
                                  _c(
                                    "q-item",
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.getLinkPlatform,
                                            target: "_blank",
                                            title: "Ver no mapa"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "margin-top": "-10px"
                                            },
                                            attrs: {
                                              id: _vm.Rota.id,
                                              src: _vm.Rota.icon,
                                              alt: _vm.Rota.name
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "q-item-main",
                                        {
                                          staticStyle: { "margin-left": "22px" }
                                        },
                                        [
                                          _vm.eventLocationName
                                            ? _c(
                                                "q-item-tile",
                                                { attrs: { label: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.eventLocationName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "q-item-tile",
                                            {
                                              staticClass: "q-mb-md",
                                              attrs: {
                                                sublabel: !!_vm.eventLocationName,
                                                label: !_vm.eventLocationName
                                              }
                                            },
                                            [
                                              _c(
                                                "address",
                                                {
                                                  attrs: {
                                                    "data-test": _vm.CypressTarget(
                                                      "Address"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(_vm.eventAddress) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.eventTimezone
                                ? _c("q-card-separator")
                                : _vm._e(),
                              _vm.eventTimezone
                                ? _c(
                                    "q-list",
                                    { attrs: { "no-border": "" } },
                                    [
                                      _c(
                                        "q-item",
                                        [
                                          _c("q-item-side", {
                                            attrs: { icon: "language" }
                                          }),
                                          _c("q-item-main", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.showTimezone) +
                                                "\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showEventIndicativeClassification &&
                              !_vm.isInfoEventPage
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "eventIndicativeClassification"
                                    },
                                    [
                                      _c("q-card-separator"),
                                      _c(
                                        "q-list",
                                        { attrs: { "no-border": "" } },
                                        [
                                          _c(
                                            "q-item",
                                            [
                                              _c("q-item-side", [
                                                _c("img", {
                                                  staticClass:
                                                    "indicativeClassificationImage",
                                                  attrs: {
                                                    src:
                                                      _vm.eventIndicativeClassificationImage
                                                  }
                                                })
                                              ]),
                                              _c("q-item-main", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.indicativeClassificationLabel
                                                    ) +
                                                    "\n                "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.visible.description &&
                              !_vm.isInfoEventPage &&
                              _vm.eventDescription
                                ? _c("q-card-separator")
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.isInfoEventPage && !_vm.isFutureEvent) ||
                      (_vm.visible.description &&
                        _vm.eventDescription &&
                        (_vm.menuActive === _vm.getMenuInformations ||
                          (!_vm.$q.platform.is.mobile && !_vm.isFutureEvent)))
                        ? _c("p", {
                            directives: [
                              {
                                name: "dompurify-html",
                                rawName: "v-dompurify-html",
                                value: _vm.eventDescription,
                                expression: "eventDescription"
                              }
                            ],
                            staticClass: "padding-sides fix-images",
                            attrs: {
                              "data-test": _vm.CypressTarget("Description")
                            }
                          })
                        : _vm._e(),
                      _vm._t("default")
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }